import { useRef } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { useErrorToast } from '@/core/errors/useErrorToast';

const reasons: Record<string, string> = {
  INVALID_TOTAL: 'Informe um valor total válido e maior que zero.',
  INVALID_PERIOD: 'Revise a competência e o vencimento.', INVALID_PAYMENT: 'Revise o valor, a data e a referência do pagamento.', INVALID_REASON: 'Informe uma justificativa.',
  FUTURE_PAYMENT: 'A data do pagamento não pode estar no futuro.',
  PAYMENT_EXCEEDS_BALANCE: 'O valor excede o saldo atual. Atualize a fatura antes de continuar.',
  REQUEST_KEY_REUSED: 'Esta solicitação já foi usada com outros dados. Reabra o formulário.',
  INVOICE_CANCELED: 'Esta fatura foi cancelada.', NOT_MANUAL: 'Esta fatura não utiliza cobrança manual.',
  REVERSE_PAYMENTS_FIRST: 'Estorne as baixas antes de cancelar a fatura.',
  COMPANY_NOT_FOUND: 'Não é possível emitir faturas para esta empresa.',
  INVOICE_NOT_FOUND: 'Fatura não encontrada.', PAYMENT_NOT_FOUND: 'Pagamento não encontrado.',
};
export function useInvoiceMutation<T>(companyId: string, operation: (input: T) => Promise<unknown>, onSuccess: () => void) {
  const client = useQueryClient();
  const onError = useErrorToast();
  return useMutation({ mutationFn: operation, onSuccess: async () => {
    await client.invalidateQueries({ queryKey: queryKeys.companies.invoices(companyId) });
    await client.invalidateQueries({ queryKey: queryKeys.invoices.all });
    onSuccess();
  }, onError: (error) => {
    const reason = (error as { response?: { data?: { errors?: { invoiceReason?: string } } } }).response?.data?.errors?.invoiceReason;
    onError(error, reason ? reasons[reason] : undefined);
  } });
}
/** Preserve the key for a network retry; edits produce a different operation key. */
export function useInvoiceRequestKey() {
  const request = useRef({ payload: '', key: '' });
  return (payload: unknown) => {
    const serialized = JSON.stringify(payload);
    if (request.current.payload !== serialized) request.current = { payload: serialized, key: crypto.randomUUID() };
    return request.current.key;
  };
}
